/**
 * Queue Job Type Definitions
 *
 * This file contains type-safe job definitions for the @intentsify/queue package.
 * Uses discriminated unions to ensure type safety when processing jobs.
 */
// ============================================
// Job Names (discriminators)
// ============================================
export var PageTrackingJobName;
(function (PageTrackingJobName) {
    PageTrackingJobName["TRACK_PAGE"] = "trackPage";
    PageTrackingJobName["TRACK_PAGE_BATCH"] = "trackPageBatch";
    PageTrackingJobName["TRACK_WEBSITE_VISIT"] = "trackWebsiteVisits";
    PageTrackingJobName["GENERATE_CSV"] = "generateCsv";
    PageTrackingJobName["SEND_CSV_TO_S3"] = "sendCsvToS3";
    PageTrackingJobName["SEND_CSV_TO_S3_HOURLY"] = "sendCsvToS3Hourly";
    PageTrackingJobName["SEND_WEBSITE_VISITS_CSV_TO_S3"] = "sendWebsiteVisitsCsvToS3";
})(PageTrackingJobName || (PageTrackingJobName = {}));
export var NotificationJobName;
(function (NotificationJobName) {
    NotificationJobName["NOTIFY_USERS"] = "notifyUsers";
    NotificationJobName["CAMPAIGN_STATUS_CHANGE"] = "campaignStatusChange";
    NotificationJobName["SYNC_NOTIFICATIONS"] = "syncNotifications";
})(NotificationJobName || (NotificationJobName = {}));
export var BeeswaxJobName;
(function (BeeswaxJobName) {
    BeeswaxJobName["UPLOAD_MAID_SEGMENT"] = "maidSegment";
    BeeswaxJobName["UPLOAD_IP_SEGMENT"] = "ipAddressSegment";
    BeeswaxJobName["UPLOAD_USER_ID_SEGMENT"] = "userIdSegment";
    BeeswaxJobName["REMOVE_SEGMENT"] = "removeBeeswaxSegment";
    BeeswaxJobName["SYNC_STATUS"] = "syncBeeswaxStatus";
    BeeswaxJobName["SYNC_CAMPAIGNS"] = "beeswaxCampaigns";
    BeeswaxJobName["SYNC_CREATIVES"] = "beeswaxCreatives";
    BeeswaxJobName["SYNC_SEGMENTS"] = "beeswaxSegments";
    BeeswaxJobName["SYNC_LINE_ITEMS"] = "beeswaxLineItems";
    BeeswaxJobName["SYNC_EVENT_TAGS"] = "beeswaxEventTags";
})(BeeswaxJobName || (BeeswaxJobName = {}));
export var TradedeskJobName;
(function (TradedeskJobName) {
    TradedeskJobName["SYNC_ADVERTISERS"] = "tradedeskAdvertisers";
    TradedeskJobName["SYNC_CAMPAIGNS"] = "tradedeskCampaigns";
    TradedeskJobName["SYNC_AD_GROUPS"] = "tradedeskAdGroups";
    TradedeskJobName["SYNC_AUDIENCES"] = "tradedeskAudiences";
    TradedeskJobName["UPLOAD_IP_SEGMENT"] = "ipAddressSegment";
    TradedeskJobName["UPLOAD_MAID_SEGMENT"] = "maidSegment";
    TradedeskJobName["IP_ADDRESS_FORECASTING"] = "forecastIpAddressSegment";
})(TradedeskJobName || (TradedeskJobName = {}));
export var XandrJobName;
(function (XandrJobName) {
    XandrJobName["SYNC_CAMPAIGNS"] = "xandrCampaigns";
    XandrJobName["SYNC_INSERTION_ORDERS"] = "xandrInsertionOrders";
    XandrJobName["SYNC_LINE_ITEMS"] = "xandrLineItems";
    XandrJobName["SYNC_CREATIVES"] = "xandrCreatives";
    XandrJobName["SYNC_SEGMENTS"] = "xandrSegments";
    XandrJobName["SYNC_PROFILES"] = "xandrProfiles";
    XandrJobName["SYNC_OPERATING_SYSTEMS"] = "xandrOperatingSystems";
    XandrJobName["UPLOAD_IP_SEGMENT"] = "ipAddressSegment";
    XandrJobName["UPLOAD_MAID_SEGMENT"] = "maidSegment";
    XandrJobName["EDIT_IP_SEGMENT"] = "editIpAddressSegment";
    XandrJobName["EDIT_MAID_SEGMENT"] = "editMaidSegment";
})(XandrJobName || (XandrJobName = {}));
export var ConvertrJobName;
(function (ConvertrJobName) {
    ConvertrJobName["SYNC_LEADS"] = "convertrLeads";
    ConvertrJobName["SYNC_LEADS_REPULL"] = "convertrLeadsRepull";
    ConvertrJobName["SYNC_LEADS_ON_DEMAND"] = "convertrLeadsOnDemand";
    ConvertrJobName["SYNC_CAMPAIGNS"] = "convertrCampaigns";
    ConvertrJobName["SYNC_CAMPAIGN_PUBLISHERS"] = "convertrCampaignPublishers";
})(ConvertrJobName || (ConvertrJobName = {}));
export var SalesforceJobName;
(function (SalesforceJobName) {
    SalesforceJobName["SYNC_DATA"] = "salesforceSyncData";
    SalesforceJobName["INTERNAL_SYNC"] = "salesforceInternal";
})(SalesforceJobName || (SalesforceJobName = {}));
export var MondayJobName;
(function (MondayJobName) {
    MondayJobName["SYNC_DATA"] = "mondaySyncData";
})(MondayJobName || (MondayJobName = {}));
export var TrustradiusJobName;
(function (TrustradiusJobName) {
    TrustradiusJobName["SYNC_DATA"] = "trustradiusSyncData";
})(TrustradiusJobName || (TrustradiusJobName = {}));
export var BeeswaxCommandJobName;
(function (BeeswaxCommandJobName) {
    BeeswaxCommandJobName["PREPARE_AUTOMATED_SEGMENT_UPLOAD"] = "prepareAutomatedSegmentUpload";
})(BeeswaxCommandJobName || (BeeswaxCommandJobName = {}));
export var XandrCommandJobName;
(function (XandrCommandJobName) {
    XandrCommandJobName["EDIT_PROGRAMMATIC_SEGMENT"] = "editProgrammaticSegment";
})(XandrCommandJobName || (XandrCommandJobName = {}));
export var TradedeskCommandJobName;
(function (TradedeskCommandJobName) {
    TradedeskCommandJobName["PREPARE_AUTOMATED_SEGMENT_UPLOAD"] = "prepareAutomatedSegmentUpload";
})(TradedeskCommandJobName || (TradedeskCommandJobName = {}));
export var AutomatedBulkUpdatesJobName;
(function (AutomatedBulkUpdatesJobName) {
    AutomatedBulkUpdatesJobName["REQUEST_TAL_UPDATE"] = "requestTALUpdate";
})(AutomatedBulkUpdatesJobName || (AutomatedBulkUpdatesJobName = {}));
//# sourceMappingURL=Queue.js.map